import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { MatchingSource, Recommendation, RecommendationFilters, Recommendations } from './matching.types';
import { useMatchingRead } from './useMatchingRead';

export { MATCHING_QUERY_KEY } from './useMatchingRead';

// Canonical repeated keys: Spring rejects comma-separated arrays and [] suffixes.
export const recommendationParams = (
  source: MatchingSource,
  filters: RecommendationFilters,
  from: number,
  max: number
) => {
  const params = new URLSearchParams({ from: String(from), max: String(max) });
  if (filters.minScore !== undefined) params.set('minScore', String(filters.minScore));
  if (filters.freshness && filters.freshness !== 'all') params.set('freshness', filters.freshness);
  if (source.type === 'candidate' && filters.active !== undefined) params.set('active', String(filters.active));
  if (filters.excludeExistingRecruitment) params.set('excludeExistingRecruitment', 'true');
  Array.from(new Set(filters.budgetStatus))
    .sort()
    .forEach((value) => params.append('budgetStatus', value));
  Array.from(new Set(filters.excludeRecruitmentStatusIds))
    .sort((a, b) => a - b)
    .forEach((value) => params.append('excludeRecruitmentStatusIds', String(value)));
  return params.toString();
};

export const useRecommendations = (
  source: MatchingSource,
  filters: RecommendationFilters,
  from: number,
  max: number,
  open: boolean
) => {
  const params = recommendationParams(source, filters, from, max);
  const route = source.type === 'candidate' ? ApiRoutesEnum.recommendedProjects : ApiRoutesEnum.recommendedCandidates;
  return useMatchingRead<Recommendations<Recommendation>>(
    [source.type, source.uuid, params],
    pathToUrl(route, { id: source.uuid || 'missing' }),
    open && !!source.uuid,
    new URLSearchParams(params)
  );
};
